import { createAction, createReducer } from '@reduxjs/toolkit';
import type { RootState } from '@store/types';
import type { LanguageState } from './types';

// Re-export types for consumers
export type { LanguageState } from './types';

const initState: LanguageState = {
  labelSwitchedOn: false,
};

// === Actions ===

export const updateLabelSwitchedOn = createAction('updateLabelSwitchedOn');

// === Selectors ===

export const selectLabelSwitchedOn = (state: RootState) => state.language.labelSwitchedOn;

// === Reducer ===

export default createReducer<LanguageState>(initState, {
  [updateLabelSwitchedOn.type]: (state) => {
    return { ...state, labelSwitchedOn: !state.labelSwitchedOn };
  },
});
